// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__ehzTp","rotate":"Loader_rotate___9CoT"};